import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  useMediaQuery,
  TextField,
  Button,
  Tabs,
  Tab,
  Input,
  Avatar,
} from "@mui/material";
import Swal from "sweetalert2";
import { useAuth } from "../../../AuthProvider";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";

// import { useCompany } from "../CompanyContext/CompanyContext";
const baseUrl = process.env.REACT_APP_API_BASE_URL;
const OrganizationProfile = () => {
  const [tabIndex, setTabIndex] = useState(0); // Track which tab is selected
  const [isSaving, setIsSaving] = useState(false); // Track if the save button is clicked
  const [companyInfo, setCompanyInfo] = useState({
    schoolName: "",
    pincode: "",
    primaryContact: "",
    secondaryContact: "",
    boardAffiliation: "",
    schoolAddress: "",
    affiliationNumber: "",
    city: "",
    state: "",
    schoolEmailId: "",
    schoolLogo: "",
    schoolStamp: "",
  });
  const [loading, setLoading] = useState(true); // Loader state
  const { userId, triggerRefresh, oId } = useAuth();
  const [editableState, setEditableState] = useState({
    0: false, // Editable state for "Company Details" tab
    1: false, // Editable state for "Upload Documents" tab
  });

  //   const { setCompanyInfo: setCompanyContextInfo } = useCompany(); // Use context to set companyInfo

  const [tempInfo, setTempInfo] = useState({ ...companyInfo });

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/v1/organisation/${oId}`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setCompanyInfo({
          schoolLogo: data.schoolLogo,
          schoolStamp: data.schoolStamp,
          schoolName: data.schoolName,
          city: data.city,
          state: data.state,
          affiliationNumber: data.affiliationNumber,
          schoolAddress: data.schoolAddress,
          primaryContact: data.primaryContact,
          boardAffiliation: data.boardAffiliation,
          secondaryContact: data.secondaryContact,
          pincode: data.pincode,
          schoolEmailId: data.schoolEmailId,
        });
        setTempInfo(data);

        setLoading(false); // Data fetched, stop loading
      } catch (error) {
        console.error("Error fetching company info:", error);
        setLoading(false); // Stop loading even if there's an error
      }
    };

    fetchCompanyInfo();
  }, []);
  //   [setCompanyContextInfo]

  const handleEdit = () => {
    setEditableState((prev) => ({ ...prev, [tabIndex]: true }));
  };

  const handleSave = async () => {
    setIsSaving(true); // Start loading

    const formData = new FormData();

    if (tabIndex === 0) {
      Object.keys(tempInfo).forEach((key) => {
        if (key !== "schoolLogo" && key !== "schoolStamp") {
          formData.append(key, tempInfo[key]);
        }
      });
    } else if (tabIndex === 1) {
      if (tempInfo.schoolLogo)
        formData.append("schoolLogo", tempInfo.schoolLogo);
      if (tempInfo.schoolStamp)
        formData.append("schoolStamp", tempInfo.schoolStamp);
    }

    try {
      let response;
      const url =
        tabIndex === 0
          ? `${baseUrl}/api/v1/organisation/update/${oId}`
          : `${baseUrl}/api/v1/organisation/organisation/${oId}`;

      response = await fetch(url, {
        method: "PATCH",
        body: formData,
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const updatedData = await response.json();
      setCompanyInfo(updatedData);
      // setRefreshKey((prev) => prev + 1);
      triggerRefresh("companyInfo"); // only re-fetch quiz types

      setEditableState((prev) => ({ ...prev, [tabIndex]: false }));

      console.log("RESPONSE OK, about to show toast...");
      toast.success("Profile updated successfully!", { autoClose: 1000 });
    } catch (error) {
      console.error("Error saving company info:", error);
      toast.error("Failed to update profile. Please try again.", {
        autoClose: 2000,
      });
    } finally {
      setIsSaving(false); // End loading
    }
  };

  const handleCancel = () => {
    setTempInfo({ ...companyInfo });
    setEditableState((prev) => ({ ...prev, [tabIndex]: false }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTempInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];

    if (file) {
      const fileType = file.type;
      const fileSize = file.size / 1024 / 1024;

      if (!["image/jpeg", "image/png"].includes(fileType)) {
        Swal.fire("Error", "Only JPEG and PNG files are allowed.", "error");
        return;
      }

      if (fileSize > 1) {
        Swal.fire("Error", "File size must be less than 1MB.", "error");
        return;
      }

      setTempInfo((prev) => ({ ...prev, [name]: file }));
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
    setEditableState((prev) => ({ ...prev, [newValue]: false }));
  };

  // const formatFieldName = (field) => {
  //   if (field === "profilePic") return "Profile Picture";
  //   if (field === "document1") return "Document 1";
  //   return field;
  // };

  return (
    <Box mt={9} mx={2} display="flex" justifyContent="center">
      <Card
        sx={{
          backgroundColor: "white",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
          p: 3,
          width: "100%",
          maxWidth: isMobile ? "100%" : "1400px",
          marginBottom: 5,
          position: "relative",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            sx={{ fontSize: 24, fontWeight: "bold", marginBottom: 1 }}
          >
            Profile
          </Typography>

          {/* Company Logo and Name */}
          <Box display="flex" flexDirection="column" alignItems="center" mb={1}>
            {loading ? (
              <Typography variant="h4">Loading...</Typography>
            ) : (
              <>
                {/* <img
              src={`data:image/jpeg;base64,${companyInfo.schoolLogo}`}
              alt="School Logo"
              style={{
                maxWidth: isMobile ? "100px" : "130px",
                height: isMobile ? "100px" : "140px",
                borderRadius: "65%",
                marginBottom: "5px",
              }}
            /> */}
                <img
                  src={`data:image/jpeg;base64,${companyInfo.schoolLogo}`}
                  alt="School Logo"
                  style={{
                    width: isMobile ? "100px" : "130px", // fixed equal width
                    height: isMobile ? "100px" : "130px", // fixed equal height
                    borderRadius: "50%", // perfect circle
                    objectFit: "cover", // ensures the image fills without distortion
                    marginBottom: "5px",
                  }}
                />

                <Typography
                  variant="h5"
                  sx={{
                    fontSize: isMobile ? 20 : 24,
                    fontWeight: "bold",
                    marginTop: 1,
                    marginBottom: 5,
                    textAlign: "center",
                  }}
                >
                  {companyInfo.schoolName}
                </Typography>
              </>
            )}
          </Box>

          {/* Tab Navigation */}
          <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 3 }}>
            <Tab label="School Details" />
            <Tab label="Upload Documents" />
          </Tabs>

          {/* First Tab: Text Fields */}
          {/* {tabIndex === 0 && (
            <Grid container spacing={2}>
              <Grid item xs={12} mb={2}>
                {editableState[0] ? (
                  <TextField
                    fullWidth
                    label="School Name"
                    name="schoolName"
                    value={tempInfo.schoolName || ""}
                    onChange={handleChange}
                    variant="outlined"
                    sx={{ backgroundColor: "#E0F5F3", borderRadius: 1 }}
                  />
                ) : (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ backgroundColor: "#E0F5F3", p: 2, borderRadius: 1 }}
                  >
                    <strong style={{ fontSize: "16px" }}>School Name :</strong>{" "}
                    <strong style={{ fontSize: "18px" }}>{companyInfo.schoolName}</strong>
                  </Typography>
                )}
              </Grid>

              {[
                { label: "Affiliation Number", name: "affiliationNumber" },
                { label: "Address", name: "schoolAddress" },
                { label: "City", name: "city" },
                { label: "State", name: "state" },
                { label: "Primary Contact", name: "primaryContact" },
                { label: "Board", name: "boardAffiliation" },
                { label: "Secondary Contact", name: "secondaryContact" },
                { label: "PinCode", name: "pincode" },
                { label: "Email ID", name: "schoolEmailId" },
              ].map(({ label, name }) => (
                
                <Grid item xs={12} md={6} key={name} mb={2}>
                  {editableState[0] ? (
                    <TextField
                      fullWidth
                      label={label}
                      name={name}
                      value={tempInfo[name] || ""}
                      onChange={handleChange}
                      variant="outlined"
                      sx={{ backgroundColor: "#E0F5F3", borderRadius: 1 }}
                    />
                  ) : (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ backgroundColor: "#E0F5F3", p: 2, borderRadius: 1 }}
                    >
                      <strong style={{ fontSize: "16px" }}>{label} :</strong>{" "}
                      <strong style={{ fontSize: "18px" }}>{companyInfo[name]}</strong>
                    </Typography>
                  )}
                </Grid>
              ))}
            </Grid>
          )} */}
          {tabIndex === 0 && (
            <Grid container spacing={2}>
              <Grid item xs={12} mb={2}>
                {editableState[0] ? (
                  <TextField
                    fullWidth
                    label="School Name"
                    name="schoolName"
                    value={tempInfo.schoolName || ""}
                    onChange={handleChange}
                    variant="outlined"
                    sx={{ backgroundColor: "#E0F5F3", borderRadius: 1 }}
                  />
                ) : (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ backgroundColor: "#E0F5F3", p: 2, borderRadius: 1 }}
                  >
                    <strong style={{ fontSize: "16px" }}>School Name :</strong>{" "}
                    <strong style={{ fontSize: "18px" }}>
                      {companyInfo.schoolName}
                    </strong>
                  </Typography>
                )}
              </Grid>

              {[
                { label: "Affiliation Number", name: "affiliationNumber" },
                { label: "Address", name: "schoolAddress" },
                { label: "City", name: "city" },
                { label: "State", name: "state" },
                { label: "Primary Contact", name: "primaryContact" },
                { label: "Board", name: "boardAffiliation" },
                { label: "Secondary Contact", name: "secondaryContact" },
                { label: "PinCode", name: "pincode" },
                { label: "Email ID", name: "schoolEmailId" },
              ].map(({ label, name }) => {
                const isDisabled =
                  !editableState[0] || ["boardAffiliation"].includes(name);

                return (
                  <Grid item xs={12} md={6} key={name} mb={2}>
                    {editableState[0] ? (
                      <TextField
                        fullWidth
                        label={label}
                        name={name}
                        value={tempInfo[name] || ""}
                        onChange={handleChange}
                        variant="outlined"
                        sx={{ backgroundColor: "#E0F5F3", borderRadius: 1 }}
                        disabled={isDisabled}
                      />
                    ) : (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          backgroundColor: "#E0F5F3",
                          p: 2,
                          borderRadius: 1,
                        }}
                      >
                        <strong style={{ fontSize: "16px" }}>{label} :</strong>{" "}
                        <strong style={{ fontSize: "18px" }}>
                          {companyInfo[name]}
                        </strong>
                      </Typography>
                    )}
                  </Grid>
                );
              })}
            </Grid>
          )}

          {/* Second Tab: File Uploads */}
          {tabIndex === 1 && (
            <>
              {["schoolLogo", "schoolStamp"].map((field) => (
                <Grid item xs={12} sm={6} key={field}>
                  <Box mb={2}>
                    <Typography
                      sx={{
                        fontSize: 16,
                        backgroundColor: "#E0F5F3",
                        padding: 2,
                        borderRadius: 1,
                      }}
                    >
                      <strong>
                        {field === "schoolLogo"
                          ? "School Logo"
                          : "School Stamp"}
                        :
                      </strong>{" "}
                      {editableState[1] ? (
                        <Input
                          type="file"
                          name={field}
                          onChange={handleFileChange}
                          inputProps={{ accept: ".jpg,.jpeg,.png" }}
                          fullWidth
                        />
                      ) : field === "schoolLogo" && companyInfo[field] ? (
                        <Avatar
                          src={`data:image/jpeg;base64,${companyInfo.schoolLogo}`}
                          alt="Company Logo"
                          sx={{ width: 120, height: 120, mt: 1 }}
                        />
                      ) : field === "schoolStamp" && companyInfo[field] ? (
                        <Avatar
                          src={`data:image/jpeg;base64,${companyInfo.schoolStamp}`}
                          alt="Company Stamp"
                          sx={{ width: 120, height: 120, mt: 1 }}
                        />
                      ) : (
                        "No file uploaded"
                      )}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </>
          )}

          {/* Save/Cancel/Edit Buttons */}
          <Box display="flex" justifyContent="flex-end" mt={3}>
            {editableState[tabIndex] ? (
              <>
                {/* <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                  sx={{ mr: 2 }}
                >
                  Save

                </Button> */}
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleCancel}
                  sx={{ mr: 2 }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                  sx={{
                    minWidth: 100,
                    color: "#fff",
                    backgroundColor: "#3C3972",
                    "&:hover": { backgroundColor: "#3C3972" },
                  }}
                  disabled={isSaving}
                >
                  {isSaving ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Save"
                  )}
                </Button>
              </>
            ) : (
              <Button
                variant="contained"
                onClick={handleEdit}
                sx={{
                  mr: 2,
                  color: "#fff",
                  backgroundColor: "#3C3972",
                  "&:hover": { backgroundColor: "#3C3972" },
                }}
              >
                Edit
              </Button>
            )}
          </Box>

          <ToastContainer position="top-right" autoClose={2000} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default OrganizationProfile;
